import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { EventItem, toEventItemXml } from '../../dataObjects/EventItem';

export interface ICreateEventRequest extends IBaseRequest {
    ITEM: EventItem;
}

export class CreateEventRequest extends BaseRequest implements ICreateEventRequest {
    public ITEM: EventItem;
  constructor(server: string, session: string, item: EventItem) {
    super(server, session);
    this.ITEM = item;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    
    parameters += '<ITEM>';
    parameters += toEventItemXml(this.ITEM);
    parameters += '</ITEM>';

    return super.wrapperXml('CreateEvent', parameters);
  }
}
